import CommonModal from '@/components/UIComponents/CommonModal';

import { Item } from './components/VideoItem';
import { VideoLibList } from './components/VideoLibList';

export const VideoLibModal = {
  open: (resolve: (value: Array<Item>) => void) => {
    CommonModal.show((t) => ({
      width: 620,
      title: t('v1.0-Add-video'),
      confirmText: t('v1.0-Add'),
      cancelText: t('merror.operate.cancel'),
      requireLogin: true,
      onConfirm: (close, contentRef) => {
        close();
        const items = contentRef.current.getSelectedItems();
        resolve(
          items.map((item: any) => {
            return {
              ...item,
              previewUrl:
                item.cover ||
                item.fileUrl +
                  '?x-oss-process=video/snapshot,ss_0,t_0,f_jpg,w_0,h_0,m_fast,ar_auto',
            };
          }),
        );
      },
      content: (close, contentRef, t) => <VideoLibList ref={contentRef} />,
    }));
  },
};

export const AudioLibModal = {
  open: (resolve: (value: Array<Item>) => void) =>
    CommonModal.show((t) => ({
      width: 620,
      title: t('v1.0-Add-audio'),
      confirmText: t('v1.0-Add'),
      cancelText: t('merror.operate.cancel'),
      requireLogin: true, // 需要登录校验
      onConfirm: (close, contentRef) => {
        close();
        const items = contentRef.current.getSelectedItems();
        resolve(
          items.map((item: any) => {
            return {
              ...item,
              previewUrl:
                item.cover ||
                item.fileUrl +
                  '?x-oss-process=video/snapshot,ss_0,t_0,f_jpg,w_0,h_0,m_fast,ar_auto',
            };
          }),
        );
      },
      content: (close, contentRef) => <VideoLibList ref={contentRef} type={5} />,
    })),
};

export const ImageLibModal = {
  open: (resolve: (value: Array<Item>) => void) =>
    CommonModal.show((t) => ({
      width: 620,
      title: t('v1.0-Add-image'),
      confirmText: t('v1.0-Add'),
      cancelText: t('merror.operate.cancel'),
      requireLogin: true, // 需要登录校验
      onConfirm: (close, contentRef) => {
        close();
        const items = contentRef.current.getSelectedItems();
        resolve(
          items.map((item: any) => {
            return {
              ...item,
              previewUrl:
                item.cover ||
                item.fileUrl +
                  '?x-oss-process=video/snapshot,ss_0,t_0,f_jpg,w_0,h_0,m_fast,ar_auto',
            };
          }),
        );
      },
      content: (close, contentRef, t) => <VideoLibList ref={contentRef} type={2} />,
    })),
};
